<template>
    <div>
        <limitless-page-header>
            <template #header-elements>
                <limitless-page-header-button url="/products/categories/sort" icon="icon-arrow-resize8">Sortera produkter</limitless-page-header-button>
                <limitless-page-header-button url="/products/categories/0" icon="icon-plus3">Ny kategori</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <div v-if="!initialized && busy"><i class="icon-spinner2 spinner"></i></div>
            <div v-else>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="card-group-control card-group-control-left">
                            <div class="card">
                                <draggable v-model="categories" group="categories" handle=".handle">
                                    <div v-for="cat in categories" :key="'hc-' + cat.ProdCatID">
                                        <div class="card-header border-bottom p-2">
                                            <h6 class="card-title d-inline">
                                                <a v-if="sub_categories[cat.ProdCatID]" class="text-body" style="cursor: pointer;" v-b-toggle="'cc-' + cat.ProdCatID">&hairsp;</a>
                                            </h6>
                                            <a :href="'/products/categories/' + cat.ProdCatID" :style="{ 'padding-left': (sub_categories[cat.ProdCatID] ? '0' : '30px') }">#{{ cat.ProdCatID }} - {{ cat.categoryName }}</a>
                                            <span class="badge badge-light ml-2">{{ cat.products_count || 0 }} produkter</span>
                                            <div class="handle"><i class="icon-arrow-resize8"></i></div>
                                        </div>
                                        <b-collapse :id="'cc-' + cat.ProdCatID" v-if="sub_categories[cat.ProdCatID]">
                                            <draggable v-model="sub_categories[cat.ProdCatID]" group="subcategories" handle=".handle">
                                                <div class="card-header border-bottom" style="padding: 10px 10px 10px 95px;" v-for="scat in sub_categories[cat.ProdCatID]" :key="'hsc-' + scat.SubCategoryID">
                                                    <a :href="'/products/categories/' + cat.ProdCatID">#{{ scat.SubCategoryID }} - {{ scat.SubCategoryName }}</a>
                                                    <span class="badge badge-light ml-2">{{ scat.products_count || 0 }} produkter</span>
                                                    <div class="handle"><i class="icon-arrow-resize8"></i></div>
                                                </div>
                                            </draggable>
                                        </b-collapse>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                    </div>
                </div>

                <limitless-button ref="btnsavesort" @click="saveSort" icon="icon-floppy-disk" :busy="busy">SPARA</limitless-button>
            </div>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import apiClient from '@services/ApiClient';
import draggable from 'vuedraggable';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';

export default {
    name: 'ProductCategoryTree',
    components: {
        LimitlessButton,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        draggable,
    },
    data: () => ({
        initialized: false,
        busy: true,
        categories: [],
        sub_categories: {},
    }),
    async mounted() {
        await this.getCategories();
        await this.getSubCategories();
        this.initialized = true;
        this.busy = false;
    },
    methods: {
        async getCategories() {
            await apiClient.get('/vue/product_categories?sort_by_column=sortNo&sort_by_order=asc&per_page=1000')
                .then((response) => {
                    if (response.data && response.data.data) {
                        this.categories = response.data.data;
                    }
                });
        },
        async getSubCategories() {
            await apiClient.get('/vue/product_sub_categories?sort_by_column=SubCategorySortno&sort_by_order=asc&per_page=1000')
                .then((response) => {
                    if (response.data && response.data.data) {
                        const obj = {};
                        response.data.data.forEach((cat) => {
                            if (!obj[cat.MainCategoryID]) {
                                obj[cat.MainCategoryID] = [];
                            }
                            obj[cat.MainCategoryID].push(cat);
                        });
                        this.sub_categories = obj;
                    }
                });
        },
        async saveSort() {
            this.busy = true;

            const postData = {
                categories: [],
                sub_categories: [],
            };
            Object.entries(this.categories).forEach(([index, cat]) => {
                postData.categories.push({
                    ProdCatID: cat.ProdCatID,
                    sortNo: parseInt(index, 10) + 1,
                });
            });
            Object.keys(this.sub_categories).forEach((MainCategoryID) => {
                Object.entries(this.sub_categories[MainCategoryID]).forEach(([index, cat]) => {
                    postData.sub_categories.push({
                        SubCategoryID: cat.SubCategoryID,
                        SubCategorySortno: parseInt(index, 10) + 1,
                        MainCategoryID,
                    });
                });
            });

            await apiClient.post('/vue/product_categories/sort', postData)
                .then(() => {
                    this.$refs.btnsavesort.triggerSaved();
                })
                .catch((error) => {
                    if (error.response) {
                        const { status } = error.response;
                        const { data } = error.response;
                        if (status === 422) {
                            let message = 'Valideringsfel... ';
                            if (data.message) {
                                message += data.message;
                            }
                            this.$swal({
                                icon: 'error',
                                title: 'Error!',
                                text: message,
                                reverseButtons: true,
                                confirmButtonText: 'OK',
                                cancelButtonText: 'Avbryt',
                            });
                        }
                    }

                    this.$refs.btnsavesort.triggerFailed();
                })
                .finally(() => {
                    this.busy = false;
                });
        },
    },
};

</script>

<style scoped lang="scss">
.sortable-ghost {
    border: 1px dashed #aaa;
    position: relative;
    box-shadow: none;
    -webkit-box-shadow: none;
}

.sortable-ghost:before {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #ffffff;
    z-index: 10;
    padding: 5px;
}
.handle {
    float: right;
    cursor: pointer;
}
</style>
